<div class="checkout-page">

  <!-- LEFT: Billing Details -->
  <div class="billing-section">
    <h2 class="h2f"><img class="back" (click)="goBack()" src="assets/images/leftArrow.png" /> Billing Details</h2>

    <div class="form-row">
      <div class="form-group">
        <label>First Name <span class="required">*</span></label>
        <input type="text" [(ngModel)]="firstName" [class.error-input]="firstNameError" required />
        <span class="error-message" *ngIf="firstNameError">{{firstNameError}}</span>
      </div>

      <div class="form-group">
        <label>Last Name <span class="required">*</span></label>
        <input type="text" [(ngModel)]="lastName" [class.error-input]="lastNameError" required />
        <span class="error-message" *ngIf="lastNameError">{{lastNameError}}</span>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label>
          Phone <span class="required">*</span>
          <span *ngIf="isMobileReadonly" class="readonly-indicator"
            title="This field cannot be edited as it is verified on your account">
            <i class="bi bi-lock-fill"></i>
          </span>
        </label>
        <input type="tel" [(ngModel)]="phone" maxlength="10" [class.error-input]="phoneError"
          [class.readonly-input]="isMobileReadonly" [readonly]="isMobileReadonly" [disabled]="isMobileReadonly"
          required />
        <span class="error-message" *ngIf="phoneError">{{phoneError}}</span>
      </div>

      <div class="form-group">
        <label>
          Email Address <span class="required">*</span>
          <span *ngIf="isEmailReadonly" class="readonly-indicator"
            title="This field cannot be edited as it is verified on your account">
            <i class="bi bi-lock-fill"></i>
          </span>
        </label>
        <input type="email" [(ngModel)]="email" [class.error-input]="emailError"
          [class.readonly-input]="isEmailReadonly" [readonly]="isEmailReadonly" [disabled]="isEmailReadonly" required />
        <span class="error-message" *ngIf="emailError">{{emailError}}</span>
      </div>
    </div>

    <div class="form-group">
      <label>Country / Region <span class="required">*</span></label>
      <input type="text" value="India" disabled />
    </div>

  </div>

  <!-- RIGHT: Order Summary -->
  <div class="order-section">
    <h2 class="h2f">Your Payment</h2>

    <div class="order-box">
      <div class="product-row">
        <div>
          <strong>Slot for {{slot.slot_time}}</strong>
          <p>Slot: 1</p>
        </div>
        <span class="price">₹{{lawyer.amount | number:'1.2-2'}}</span>
      </div>

      <hr />

      <!-- Coupon Code Section -->
      <div class="coupon-section">
        <div class="coupon-input-group" *ngIf="!couponApplied">
          <div class="coupon-input-wrapper">
            <i class="bi bi-tag coupon-icon"></i>
            <input type="text" [(ngModel)]="couponCode" placeholder="Enter coupon code" class="coupon-input"
              (keyup.enter)="applyCoupon()" />
          </div> 
          <!--TODO: Implement coupon validation API -->
          <!-- <button class="coupon-apply-btn" [disabled]="!couponCode?.trim() || applyingCoupon" (click)="applyCoupon()">
            {{ applyingCoupon ? 'Checking...' : 'Apply' }}
          </button> -->
        </div>

        <!-- Applied state -->
        <div class="coupon-applied-chip" *ngIf="couponApplied">
          <i class="bi bi-check-circle-fill"></i>
          <span>{{couponCode}} applied</span>
          <button class="coupon-remove-btn" (click)="removeCoupon()">Remove</button>
        </div>

        <span class="coupon-error" *ngIf="couponError">{{couponError}}</span>
        <span class="coupon-success" *ngIf="couponApplied && couponMessage">{{couponMessage}}</span>
      </div>

      <hr />

      <!-- Price Summary Section -->
      <div class="price-summary-section" *ngIf="finalAmount > 0">
        <div class="price-summary-header" (click)="isPriceSummaryExpanded = !isPriceSummaryExpanded">
          <span class="price-summary-title">Price Details</span>
          <i class="bi" [class.bi-chevron-up]="isPriceSummaryExpanded"
            [class.bi-chevron-down]="!isPriceSummaryExpanded"></i>
        </div>

        <div class="price-summary-body" *ngIf="isPriceSummaryExpanded">
          <div class="summary-row" *ngFor="let item of priceSummary?.line_items">
            <span>{{item.label}}</span>
            <span>₹{{item.amount | number:'1.2-2'}}</span>
          </div>
          <div class="summary-row discount-row" *ngIf="couponApplied && couponDiscount > 0">
            <span>Coupon Discount</span>
            <span>-₹{{couponDiscount | number:'1.2-2'}}</span>
          </div>
        </div>

        <div class="summary-row total-payable">
          <span>{{priceSummary?.totals?.final_amount_label || 'Total Payable'}}</span>
          <span>₹{{(finalAmount - (couponApplied ? couponDiscount : 0)) | number:'1.2-2'}}</span>
        </div>
      </div>

      <div class="loading-preview" *ngIf="loadingPriceSummary">Loading price details...</div>

      <!-- Preview API failed — booking is blocked until the price loads -->
      <div class="preview-error" *ngIf="previewError && !loadingPriceSummary">
        <i class="bi bi-exclamation-triangle-fill"></i>
        <span>Unable to load price details. Please retry to continue booking.</span>
        <button type="button" class="preview-retry-btn" (click)="getCheckoutPreview()">Retry</button>
      </div>

      <hr />

      <div class="payment-box">
        <h4 class="h2f2">Online Payment</h4>
        <div class="razorpay">
          <img src="assets/images/rzp_payicon2.png" />
          <span>Pay by Razorpay</span>
        </div>
        <p class="secure-text">
          Pay securely by UPI, Credit or Debit card via Razorpay.<br />
          We only support online payments.
        </p>
      </div>

      <!--<button class="place-order-btn" (click)="payAppointment()">Book Slot</button> -->
      <div class="button-group">
        <button class="btn-cancel" (click)="goBack()">Cancel</button>
        <button class="place-order-btn" (click)="payAppointment()"
          [disabled]="loadingPriceSummary || previewError || !(finalAmount > 0)">Book Slot</button>
      </div>

    </div>
  </div>

</div>